import { createSelector } from 'reselect';

export const allProjectsSelector = state => state.newdashboard.data.get('projects').toJS();
export const activeProjectsSelector = state => state.newdashboard.selected.get('projects').toJS();

export const projectsSelector = createSelector([
    allProjectsSelector,
    activeProjectsSelector
], (all, selected) => selected.length > 0 ? all.filter(a => selected.indexOf(a.id) > -1) : []);

export const selectedProjectsSelector = createSelector([projectsSelector], list => list.map(l => l.id));

export const allGroupsSelector = state => state.newdashboard.data.get('groups').toJS();
export const activeGroupsSelector = state => state.newdashboard.selected.get('groups').toJS();

export const groupsSelector = createSelector([
    allGroupsSelector,
    activeGroupsSelector
], (all, selected) => selected.length > 0 ? all.filter(a => selected.indexOf(a.id) > -1) : []);

export const selectedGroupsSelector = createSelector([groupsSelector], list => list.map(l => l.id));

export const environmentTypesSelector = state => state.newdashboard.environmentTypes.get('list').toJS();
export const timePeriodsSelector = state => state.newdashboard.timePeriods.get('list').toJS();
export const environmentTypesLoadingSelector = state => state.newdashboard.environmentTypes.get('loading');
export const timePeriodsLoadingSelector = state => state.newdashboard.environmentTypes.get('loading');
export const projectsAndGroupsLoadingSelector = state => state.newdashboard.data.get('loading');
export const selectedProjectsAndGroupsLoadingSelector = state => state.newdashboard.data.get('loading');

 export const environmentTypesSelectorWithoutDev = state => {
    let res = state.newdashboard.environmentTypes.get('list').toJS().filter(item => item.name != "Dev");
    //All item
    var ids = [];
    res.forEach(obj => {
        ids.push(obj.id)
    });
    res = [{"id":ids,"name":"All"}, ...res];
    return res;
 };

export const baseLoadingSelector = createSelector([
    environmentTypesLoadingSelector,
    timePeriodsLoadingSelector,
    projectsAndGroupsLoadingSelector,
    selectedProjectsAndGroupsLoadingSelector,
    environmentTypesSelector,
    timePeriodsSelector,
    projectsSelector,
    groupsSelector
], (e, t, p, envs, timePeriods, projects, groups) => {
    const loading = e || t || p;
    return loading || envs.length === 0 || timePeriods.length === 0 || (projects.length === 0 && groups.length === 0);
});

export const somethingLoadingSelector = state => {
    const sectionsToCheck = ['settings', 'selected', 'environmentTypes'];
    const loading = sectionsToCheck.some(s => state.newdashboard[s].get('loading'));
    return loading;
};



// WEBPACK FOOTER //
// ./src/app/authorized/newDashBoard/selectors/base.js